<section class="indicadores-section">

  <div class="indicadores-container">

    <!-- 🔥 TÍTULO LATERAL -->
    <h2 class="titulo-lateral">INDICADORES CIA</h2>

    <!-- 🔥 CONTENIDO CENTRADO -->
    <div class="indicadores-content">

      <h3>Indicadores CIA TREN MAYA</h3>

      <!-- ICONO -->
      <div class="icono">
        <img src="assets/banners_carreras/logo_drive.png" alt="Drive">
      </div>

      <!-- LINK -->
      <a href="https://drive.google.com/drive/folders/1yYoVCrKG57PYPmUrx5Ay-fqH3ul5t1-z" class="link-indicadores">
        ■ DOCUMENTACIÓN INDICADORES CIA TREN MAYA.
      </a>

    </div>

  </div>

</section>